var TokenStorageMethod = /*#__PURE__*/function (TokenStorageMethod) {
  TokenStorageMethod["None"] = "none";
  TokenStorageMethod["Cookies"] = "cookies";
  TokenStorageMethod["LocalStorage"] = "localStorage";
  return TokenStorageMethod;
}({});

export { TokenStorageMethod };
